import React, { useState, useEffect } from 'react';
import { useGlobal, setGlobal } from 'reactn';
import { notification, Select } from 'antd';
import Card from '../../common/card/Card';
import Button from '../../common/button/Button';
import leafIcon from '../../assets/paperless.png';
import checkIcon from '../../assets/CheckIcon.png';
import xIcon from '../../assets/XIcon.png';
// autoPayDocument not in use here
// import autoPayDocument from '../../assets/documents/AUTO_PAY_FORM.pdf';
import { Controller, useForm } from 'react-hook-form';
import Form, { Input } from '../../common/form/Form';


import api from '../../../api';

const GoPaperless = ({ ...rest }) => {
  const [serviceAccounts] = useGlobal('serviceAccounts');
  const [selectedServiceAccountIndex] = useGlobal(
    'selectedServiceAccountIndex'
  );
  const { handleSubmit, control } = useForm();
  const [loading, setLoading] = useState(false);
  const [flag, setFlag] = useState(0);
  const [showOptions, setShowOptions] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showEnroll, setShowEnroll] = useState(false);
  const selectedServiceAccount = serviceAccounts[selectedServiceAccountIndex];
  const AUTO_PAY = selectedServiceAccount?.data?.AUTO_PAY;
  const EBILL_FLAG = selectedServiceAccount?.eBillStatus?.data.EBILL_FLAG;
  const { Option } = Select;
  
  // errorMessage not in use 
  // const [errorMessage, setErrorMessage] = useState(null);

  const signupHandler = async () => {
    try {
      setLoading(true);
      await api.updateEBill(
        selectedServiceAccount.data.ACCOUNT,
        selectedServiceAccount.data.CUST_CODE,
        flag
      );

      setShowConfirmation(true);
      setShowOptions(false);
      setShowEnroll(false);
      flag &&
        setGlobal({
          accountHasEbill: flag,
        });

      flag === 2 &&
        setGlobal({
          accountHasEbill: false,
        });
      setLoading(false);
      notification.success({
        message: `Your paperless preferences have been successfully updated`,
      });
    } catch (err) {
      console.log(err.response);
      setLoading(false);
    }
  };

  const billingHandler = () => async ({
    routing_number,
    banking_account_number,
    name,
    bank_account_type,
  }) => {
    name = name.substring(0,24);
    if (!routing_number || !banking_account_number || !bank_account_type || !name || !bank_account_type){
      notification.warning({
        message: `Missing values`,
      });
      return;
    }
    if (isNaN(banking_account_number) || banking_account_number.includes('.')){
      notification.warning({
        message: `Bank account number is not a valid number`,
      });
      return;
    }

    try {
      setLoading(true);
      await api.submitBillingInfo(
        selectedServiceAccount.data.ACCOUNT,
        routing_number,
        banking_account_number,
        name,
        bank_account_type,        
      );
      setShowConfirmation(true);
      setShowOptions(false);
      setShowEnroll(false);
      setLoading(false);
      notification.success({
        message: `Your billing information has been successfully updated`,
      });
    } catch (err) {
      notification.warning({
        message: `Routing number is not valid`,
      });
      console.log(err.response);
      setLoading(false);
    }
  }

  const renderConfirmation = () => {
    setTimeout(() => {
      setShowConfirmation(false);
      setShowOptions(false);
    }, 4000);
    return (
      <Card title="Go Paperless" className="flex justify-center" {...rest}>
        <div className="flex-col">
          <h3 className="font-bold mx-auto mb-8 text-center">
            YOUR BILLING INFORMATION HAS BEEN SUCCESSFULLY UPDATED.
          </h3>
          <p className="font-bold mx-auto text-center">THANK YOU.</p>
        </div>
      </Card>
    );
  };

  if (!selectedServiceAccount) return <div>NO DATA...</div>;

  const renderEnrollments = () => (
    <div id="optionsWrapper" className="w-full">
      <Card
        title="Your Enrollments"
        {...rest}
        className="flex-col justify-center"
      >
        <div className="flex align-center h-24">
		  <img
            className="h-5 w-6 my-0 mr-2"
            src={AUTO_PAY ? checkIcon : xIcon}
            alt="x-icon"
          />
          <p className={`text-bold w-1/2 h-10 my-0 mx-0`}>Automatic Bill Pay</p>
        </div>

        <div className="flex">
          <img
            className="h-5 w-6 my-0 mr-2"
            src={EBILL_FLAG ? checkIcon : xIcon}
            alt="x-icon"
          />
          <p className={`text-bold w-1/2 h-10 my-0 mx-0`}>Paperless Billing</p>
          <div
            onClick={() => {
              setShowOptions(true);
            }}
            className="my-0 ml-auto cursor-pointer"
          >
            Change Settings 
          </div>
        </div>
      </Card>
    </div>
  );

  const renderOptions = () => (
    <div id="optionsWrapper" className="w-full">
      <Card
        title="Select Billing Preference"
        {...rest}
        className="flex justify-center"
      >
        <div
          className={`text-bold border-grey border-solid border-2 border-grey-600 w-full h-10 mt-0 mb-2 mx-auto p-2 cursor-pointer ${
            flag === 1 && 'bg-blue-light text-white'
          }`}
          onClick={() => setFlag(1)}
        >
          Request E-Billing Only
        </div>
        <div
          className={`text-bold border-grey border-solid border-2 border-grey-600 w-full h-10 mt-0 mb-2 mx-auto p-2 cursor-pointer ${
            flag === null && 'bg-blue-light text-white'
          }`}
          onClick={() => setFlag(null)}
        >
          Request Paper Bill Only
        </div>
        <div
          className={`text-bold border-grey border-solid border-2 border-grey-600 w-full h-10 my-0 mx-auto p-2 cursor-pointer ${
            flag === 2 && 'bg-blue-light text-white'
          }`}
          onClick={() => setFlag(2)}
        >
          Request E-Billing & Paper Bill
        </div>
        <Button
          iconUrl={leafIcon}
          className="mx-auto w-full flex justify-center items-center"
          onClick={signupHandler}
          loading={loading}
        >
          Submit Request
        </Button>
        <Button
          disabled={loading}
          className="mx-auto w-full flex justify-center items-center"
          onClick={() => setShowOptions(false)}
          secondary
        >
          Cancel
        </Button>
      </Card>
    </div>
  );
  
  const renderEnroll = () => (
    <div id="optionsWrapper" className="w-full">
      <Card
        title="Enter Billing Info"
        {...rest}
        className="flex justify-center"
      >
        <Form
          onSubmit={handleSubmit(billingHandler())}
          className="flex flex-col"
        >
          Bank Account Type
          <Controller
          disabled={loading}
          control={control}
          name="bank_account_type"
          as={
            <Select
              style={{
                width: 185,
                marginBottom: 10,
                marginTop: 10,
              }}
              allowClear
              
            >
            <Option value="C">Checking Account</Option>
            <Option value="S">Savings Account</Option>
            </Select>
          }
          />
          <Controller
              as={<Input label="Routing Number" />}
              disabled={loading}
              control={control}
              type="text"
              id="routing-number-input"
              placeholder="Enter routing number here"
              name="routing_number"
            />
          <Controller
              as={<Input label="Banking Account Number" />}
              disabled={loading}
              control={control}
              type="text"
              id="checking-account-number"
              placeholder="Enter checking account number here"
              name="banking_account_number"
            />
          <Controller
              as={<Input label="Customer Name" />}
              disabled={loading}
              control={control}
              type="text"
              id="name-input"
              placeholder="Enter name on bank account here"
              name="name"
            />
          <Button
            iconUrl={leafIcon}
            className="mx-auto w-full flex justify-center items-center"
            htmlType="submit"
            loading={loading}
          >
            Submit Billing Info
          </Button>
          <Button
            disabled={loading}
            className="mx-auto w-full flex justify-center items-center"
            onClick={() => setShowEnroll(false)}
            secondary
          >
            Cancel
          </Button>
        </Form>
      </Card>
    </div>
  );


  if (showEnroll) {
    return renderEnroll();
  }

  if (showOptions) {
    return renderOptions();
  }

  if (showConfirmation) {
    return renderConfirmation();
  }

  return renderEnrollments();
};

export default GoPaperless;
